import { isArray, isObject } from 'utils/helpers';
import { Cell, StyledJSONTree } from './PreviewResultsTable.styled';

/**
 * getValueCell
 * Renders the JSON Tree value cell.
 * @param { Object } rowProps: Props of the row containing the value.
 * @returns { React.Component } The rendered JSON Tree.
 */
export const getValueCell = ({ value }) => <StyledJSONTree rootName={null} src={value} />;

/**
 * getValueCellForTable
 * Renders the Table value cell.
 * @param { Object } rowProps: Props of the row containing the value.
 * @returns { React.Component } The rendered JSON Tree.
 */
export const getValueCellForTable = ({ value }) => {
  if (isArray(value) || isObject(value)) {
    return getValueCell({ value });
  }
  const stringValue = value !== undefined ? `${value}` : '';
  return <Cell>{stringValue}</Cell>;
};
